<template>
  <el-menu-item
    :index="String('menu_' + item.arme_id + $randomNumber())"
    :key="'menu_' + item.arme_id + $randomNumber()"
  >
    <el-checkbox
      v-model="item.selected"
      @change="handleItemChange"
    ></el-checkbox>
    <small>
      {{ item.arme_nombre }}
    </small>
  </el-menu-item>
</template>

<script>
  export default {
    name: 'RecursiveMenuItem',
    props: {
      item: {
        type: Object,
        required: true
      }
    },
    methods: {
      handleItemChange() {
        this.$emit('item-selected')
      }
    }
  }
</script>
